import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Typography,
} from "@mui/material";

interface VcsConnectionDialogProps {
  open: boolean;
  deleting: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export function VcsConnectionDialog({
  open,
  deleting,
  onClose,
  onConfirm,
}: VcsConnectionDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={() => !deleting && onClose()}
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle>Disconnect VCS Connection?</DialogTitle>
      <DialogContent>
        <Typography variant="body2">
          This will remove the VCS connection. Existing repositories and
          webhooks will not be deleted, but Rusha will no longer be able to
          provision new repositories for this organization.
        </Typography>
      </DialogContent>
      <Divider />
      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button onClick={onClose} disabled={deleting}>
          Cancel
        </Button>
        <Button
          color="error"
          variant="contained"
          onClick={onConfirm}
          disabled={deleting}
          startIcon={
            deleting ? (
              <CircularProgress size={16} color="inherit" />
            ) : undefined
          }
        >
          Disconnect
        </Button>
      </DialogActions>
    </Dialog>
  );
}
